/* ============================================================
   ZAZA — Theme JS
   Mobile nav · AJAX cart drawer · age gate · countdown ·
   variant picker · qty controls · free-shipping bar
   ============================================================ */
(function () {
  'use strict';

  var FREESHIP = window.ZZ_FREESHIP_CENTS || 7500;

  function fmt(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------- age gate ---------- */
  function initAgeGate() {
    var gate = document.getElementById('zz-age');
    if (!gate) return;
    try {
      if (localStorage.getItem('zz21') === '1') return;
    } catch (e) { /* private mode: show gate every visit */ }
    gate.classList.add('is-open');
    document.body.classList.add('zz-lock');
    gate.querySelector('[data-zz-age-yes]').addEventListener('click', function () {
      try { localStorage.setItem('zz21', '1'); } catch (e) {}
      gate.classList.remove('is-open');
      document.body.classList.remove('zz-lock');
    });
    gate.querySelector('[data-zz-age-no]').addEventListener('click', function () {
      window.location.href = 'https://www.google.com';
    });
  }

  /* ---------- mobile nav ---------- */
  function initMobileNav() {
    var burger = document.querySelector('.zz-header__burger');
    var panel = document.getElementById('zz-mnav');
    if (!burger || !panel) return;
    burger.addEventListener('click', function () {
      var open = panel.classList.toggle('is-open');
      document.body.classList.toggle('zz-lock', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    panel.addEventListener('click', function (e) {
      if (e.target === panel || e.target.hasAttribute('data-zz-mnav-close')) {
        panel.classList.remove('is-open');
        document.body.classList.remove('zz-lock');
        burger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------- cart drawer ---------- */
  var drawer, drawerBody;

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.classList.add('zz-lock');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('zz-lock');
  }

  function renderShipBar(container, total) {
    var wrap = container.querySelector('[data-zz-shipbar]');
    if (!wrap) return;
    var left = FREESHIP - total;
    var pct = Math.min(100, Math.round((total / FREESHIP) * 100));
    wrap.querySelector('[data-zz-shipbar-fill]').style.width = pct + '%';
    wrap.querySelector('[data-zz-shipbar-label]').innerHTML =
      left > 0
        ? 'You’re <b>' + fmt(left) + '</b> away from <b>FREE shipping</b>'
        : '✓ You’ve unlocked <b>FREE shipping</b>';
    wrap.classList.toggle('is-full', left <= 0);
  }

  function renderDrawer(cart) {
    if (!drawerBody) return;
    updateCartCounts(cart.item_count);
    if (cart.item_count === 0) {
      drawerBody.innerHTML =
        '<div class="zz-drawer__empty"><p>Your cart is empty.</p>' +
        '<a href="/collections/all" class="zz-btn">Shop</a></div>';
      drawer.querySelector('.zz-drawer__foot').style.display = 'none';
      return;
    }
    drawer.querySelector('.zz-drawer__foot').style.display = '';
    var html = '';
    cart.items.forEach(function (it) {
      html +=
        '<div class="zz-line" data-zz-line-key="' + it.key + '">' +
        '<div class="zz-line__img">' +
        (it.image
          ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2') + '" alt="">'
          : '') +
        '</div>' +
        '<div class="zz-line__mid">' +
        '<div class="zz-line__nm">' + it.product_title + '</div>' +
        (it.variant_title && it.variant_title !== 'Default Title'
          ? '<div class="zz-line__var">' + it.variant_title + '</div>'
          : '') +
        '<div class="zz-qty" data-zz-qty>' +
        '<button type="button" data-zz-qty-dec aria-label="Decrease">&minus;</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" data-zz-qty-inc aria-label="Increase">+</button>' +
        '</div>' +
        '</div>' +
        '<div class="zz-line__right">' +
        '<div class="zz-line__price">' + fmt(it.final_line_price) + '</div>' +
        '<button type="button" class="zz-line__rm" data-zz-rm aria-label="Remove">Remove</button>' +
        '</div>' +
        '</div>';
    });
    drawerBody.innerHTML = html;
    drawer.querySelector('[data-zz-subtotal]').textContent = fmt(cart.total_price);
    renderShipBar(drawer, cart.total_price);
  }

  function updateCartCounts(n) {
    document.querySelectorAll('[data-zz-cart-count]').forEach(function (el) {
      el.textContent = n;
    });
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function initDrawer() {
    drawer = document.getElementById('zz-drawer');
    if (!drawer) return;
    drawerBody = drawer.querySelector('.zz-drawer__body');

    document.querySelectorAll('[data-zz-cart-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        fetchCart().then(renderDrawer);
        openDrawer();
      });
    });
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer || e.target.hasAttribute('data-zz-drawer-close')) closeDrawer();

      var line = e.target.closest('[data-zz-line-key]');
      if (!line) return;
      var key = line.getAttribute('data-zz-line-key');
      var qtyEl = line.querySelector('[data-zz-qty] span');
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      if (e.target.hasAttribute('data-zz-qty-inc')) changeLine(key, qty + 1).then(renderDrawer);
      if (e.target.hasAttribute('data-zz-qty-dec')) changeLine(key, Math.max(0, qty - 1)).then(renderDrawer);
      if (e.target.hasAttribute('data-zz-rm')) changeLine(key, 0).then(renderDrawer);
    });

    /* intercept all product forms for AJAX add */
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.disabled = true; btn.dataset.orig = btn.textContent; btn.textContent = 'Adding…'; }
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return fetchCart();
          })
          .then(function (cart) {
            renderDrawer(cart);
            openDrawer();
          })
          .catch(function () {
            alert('Could not add to cart. Please try again.');
          })
          .finally(function () {
            if (btn) { btn.disabled = false; btn.textContent = btn.dataset.orig; }
          });
      });
    });
  }

  /* ---------- cart page ---------- */
  function initCartPage() {
    var page = document.querySelector('[data-zz-cartpage]');
    if (!page) return;
    page.addEventListener('click', function (e) {
      var line = e.target.closest('[data-zz-line-key]');
      if (!line) return;
      var key = line.getAttribute('data-zz-line-key');
      var qtyEl = line.querySelector('[data-zz-qty] span');
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      var done = function () { window.location.reload(); };
      if (e.target.hasAttribute('data-zz-qty-inc')) changeLine(key, qty + 1).then(done);
      if (e.target.hasAttribute('data-zz-qty-dec')) changeLine(key, Math.max(0, qty - 1)).then(done);
      if (e.target.hasAttribute('data-zz-rm')) changeLine(key, 0).then(done);
    });
    fetchCart().then(function (cart) { renderShipBar(page, cart.total_price); });
  }

  /* ---------- countdown (auto next-Thursday or manual) ---------- */
  function nextDrop(dayOfWeek, hh, mm) {
    var now = new Date();
    var d = new Date(now);
    d.setHours(hh, mm, 0, 0);
    var add = (dayOfWeek - d.getDay() + 7) % 7;
    if (add === 0 && d <= now) add = 7;
    d.setDate(d.getDate() + add);
    return d;
  }

  function initCountdown() {
    document.querySelectorAll('[data-zz-countdown]').forEach(function (el) {
      var clock = el.querySelector('[data-zz-clock]');
      var mode = el.getAttribute('data-zz-mode') || 'auto';
      var target;

      function computeTarget() {
        if (mode === 'manual') {
          var t = new Date(el.getAttribute('data-zz-countdown'));
          return isNaN(t.getTime()) ? null : t;
        }
        return nextDrop(4, 16, 20); /* Thursday 4:20pm local */
      }
      target = computeTarget();
      if (!target || !clock) return;

      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var now = Date.now();
        var diff = target.getTime() - now;
        /* LIVE NOW window: 8h after drop time (auto mode) */
        if (mode === 'auto' && diff < -0) {
          target = computeTarget();
          diff = target.getTime() - now;
        }
        var sinceLast = 604800000 - diff; /* ms since previous weekly drop */
        if (mode === 'auto' && sinceLast >= 0 && sinceLast < 28800000) {
          clock.textContent = 'LIVE NOW';
          return;
        }
        if (diff < 0) { clock.textContent = 'LIVE NOW'; return; }
        var days = Math.floor(diff / 86400000),
          hrs = Math.floor(diff % 86400000 / 3600000),
          min = Math.floor(diff % 3600000 / 60000),
          sec = Math.floor(diff % 60000 / 1000);
        clock.textContent = pad(days) + ' : ' + pad(hrs) + ' : ' + pad(min) + ' : ' + pad(sec);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- PDP: variant picker + gallery + qty ---------- */
  function initProduct() {
    var root = document.querySelector('[data-zz-product]');
    if (!root) return;
    var dataEl = root.querySelector('[data-zz-product-json]');
    var product = dataEl ? JSON.parse(dataEl.textContent) : null;

    /* gallery */
    root.querySelectorAll('[data-zz-thumb]').forEach(function (th) {
      th.addEventListener('click', function () {
        var main = root.querySelector('[data-zz-main-img]');
        if (main) main.src = th.getAttribute('data-zz-thumb');
        root.querySelectorAll('[data-zz-thumb]').forEach(function (t) { t.classList.remove('is-on'); });
        th.classList.add('is-on');
      });
    });

    /* qty stepper */
    var qty = root.querySelector('[data-zz-pqty]');
    if (qty) {
      var input = qty.querySelector('input');
      qty.querySelector('[data-zz-qty-dec]').addEventListener('click', function () {
        input.value = Math.max(1, parseInt(input.value, 10) - 1);
      });
      qty.querySelector('[data-zz-qty-inc]').addEventListener('click', function () {
        input.value = parseInt(input.value, 10) + 1;
      });
    }

    /* variant selects */
    if (!product || !product.variants || product.variants.length < 2) return;
    var selects = root.querySelectorAll('[data-zz-opt]');
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-zz-price]');
    var cmpEl = root.querySelector('[data-zz-compare]');
    var btn = root.querySelector('[data-zz-atc]');

    function currentVariant() {
      var chosen = [];
      selects.forEach(function (s) { chosen[parseInt(s.getAttribute('data-zz-opt'), 10)] = s.value; });
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
    }
    function sync() {
      var v = currentVariant();
      if (!v) {
        if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = fmt(v.price);
      if (cmpEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          cmpEl.textContent = fmt(v.compare_at_price);
          cmpEl.style.display = '';
        } else cmpEl.style.display = 'none';
      }
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? 'Add To Cart' : 'Sold Out';
      }
      if (v.featured_image && v.featured_image.src) {
        var main = root.querySelector('[data-zz-main-img]');
        if (main) main.src = v.featured_image.src;
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', sync); });
    sync();
  }

  /* ---------- horizontal product rows ---------- */
  function initRows() {
    document.querySelectorAll('.zz-rowwrap').forEach(function (wrap) {
      var row = wrap.querySelector('[data-zz-row]');
      var prev = wrap.querySelector('[data-zz-row-prev]');
      var next = wrap.querySelector('[data-zz-row-next]');
      if (!row || !prev || !next) return;
      function page() {
        var card = row.querySelector('.zz-card');
        var step = card ? card.offsetWidth + 28 : row.clientWidth;
        return Math.max(step, row.clientWidth - step);
      }
      function update() {
        var max = row.scrollWidth - row.clientWidth - 2;
        prev.classList.toggle('is-off', row.scrollLeft <= 2);
        next.classList.toggle('is-off', row.scrollLeft >= max);
      }
      prev.addEventListener('click', function () { row.scrollBy({ left: -page(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { row.scrollBy({ left: page(), behavior: 'smooth' }); });
      row.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- deal countdowns (calendar boundaries, Pacific time) ---------- */
  function initDealTimers() {
    var timers = document.querySelectorAll('[data-zz-deal-timer]');
    if (!timers.length) return;
    var laFmt = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles', hourCycle: 'h23', weekday: 'short',
      year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', second: 'numeric'
    });
    var DOW = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 };
    function secondsLeft(period) {
      var o = {};
      laFmt.formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
      var left = 86400 - (Number(o.hour) * 3600 + Number(o.minute) * 60 + Number(o.second));
      if (period === 'week') left += (6 - DOW[o.weekday]) * 86400;
      if (period === 'month') {
        var dim = new Date(Number(o.year), Number(o.month), 0).getDate();
        left += (dim - Number(o.day)) * 86400;
      }
      return left;
    }
    function fmtLeft(s) {
      var d = Math.floor(s / 86400); s -= d * 86400;
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      return (d > 0 ? d + 'd ' : '') +
        pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
    }
    function tick() {
      timers.forEach(function (t) {
        var clock = t.querySelector('[data-zz-deal-clock]');
        if (clock) clock.textContent = fmtLeft(secondsLeft(t.getAttribute('data-period') || 'day'));
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- fixed-target countdown (Exclusive next drop, Pacific) ---------- */
  function initUntil() {
    var els = document.querySelectorAll('[data-zz-until]');
    if (!els.length) return;
    function tick() {
      els.forEach(function (el) {
        var clock = el.querySelector('[data-zz-until-clock]');
        if (!clock) return;
        // interpret the configured time as Pacific by comparing against LA-now
        var target = new Date(el.getAttribute('data-zz-until'));
        var laNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
        var s = Math.floor((target - laNow) / 1000);
        if (isNaN(s)) { clock.textContent = '—'; return; }
        if (s <= 0) { clock.textContent = 'LIVE NOW'; return; }
        var d = Math.floor(s / 86400); s -= d * 86400;
        var pad = function (n) { return (n < 10 ? '0' : '') + n; };
        clock.textContent = (d > 0 ? d + 'd ' : '') +
          pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- hero slideshow ---------- */
  function initHeroSlider() {
    var root = document.querySelector('[data-zz-hero]');
    if (!root) return;
    var slides = root.querySelectorAll('.zz-heroslide');
    if (slides.length < 2) return;
    var dots = root.querySelectorAll('[data-zz-hero-dot]');
    var i = 0, timer;
    function go(n) {
      slides[i].classList.remove('is-on');
      if (dots[i]) dots[i].classList.remove('is-on');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-on');
      if (dots[i]) dots[i].classList.add('is-on');
    }
    function auto() { timer = setInterval(function () { go(i + 1); }, 9000); }
    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { clearInterval(timer); go(n); auto(); });
    });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', function () { clearInterval(timer); auto(); });
    auto();
  }

  /* ---------- recently viewed (localStorage) ---------- */
  function initRecent() {
    var KEY = 'zz-recent';
    var current = document.querySelector('[data-zz-handle]');
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
    var handle = current && current.getAttribute('data-zz-handle');
    var toShow = list.filter(function (h) { return h !== handle; }).slice(0, 8);
    if (handle) {
      var next = [handle].concat(toShow).slice(0, 12);
      try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) {}
    }
    var wrap = document.querySelector('[data-zz-recent]');
    var row = document.querySelector('[data-zz-recent-row]');
    if (!wrap || !row || !toShow.length) return;
    Promise.all(toShow.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (prods) {
      var cards = prods.filter(Boolean).map(function (p) {
        var src = p.featured_image
          ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=400'
          : '';
        var img = src ? '<img src="' + src + '" loading="lazy" alt="">' : '';
        return '<a href="' + p.url + '" class="zz-card">' +
          '<div class="zz-card__ph">' + img + '</div>' +
          '<div class="zz-card__body"><div class="zz-card__nm">' + p.title + '</div>' +
          '<div class="zz-card__row"><span class="zz-card__price">' + fmt(p.price) + '</span></div></div></a>';
      }).join('');
      if (cards) { row.innerHTML = cards; wrap.hidden = false; }
    });
  }

  /* ---------- predictive search (Shopify suggest API) ---------- */
  function initSuggest() {
    document.querySelectorAll('.zz-searchwrap').forEach(function (wrap) {
      var input = wrap.querySelector('[data-zz-suggest]');
      var dd = wrap.querySelector('[data-zz-suggest-dd]');
      if (!input || !dd) return;
      var timer, lastQ = '';
      function hide() { dd.hidden = true; dd.innerHTML = ''; }
      function render(q, products) {
        if (!products.length) { hide(); return; }
        var html = products.map(function (p) {
          var img = p.image ? '<img src="' + p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" loading="lazy" alt="">' : '';
          return '<a class="zz-suggest__item" href="' + p.url + '">' +
            '<span class="zz-suggest__img">' + img + '</span>' +
            '<span class="zz-suggest__mid"><span class="zz-suggest__nm">' + p.title + '</span>' +
            '<span class="zz-suggest__pr">' + p.price + '</span></span></a>';
        }).join('');
        html += '<a class="zz-suggest__all" href="/search?q=' + encodeURIComponent(q) + '">See all results for &ldquo;' + q.replace(/</g, '&lt;') + '&rdquo; &rarr;</a>';
        dd.innerHTML = html;
        dd.hidden = false;
      }
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { hide(); return; }
        timer = setTimeout(function () {
          lastQ = q;
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
                '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
            .then(function (r) { return r.json(); })
            .then(function (d) {
              if (q !== lastQ) return;
              var prods = (d.resources && d.resources.results && d.resources.results.products) || [];
              render(q, prods.map(function (p) {
                return { title: p.title, url: p.url, image: p.featured_image && p.featured_image.url, price: p.price ? '$' + p.price : '' };
              }));
            })
            .catch(hide);
        }, 200);
      });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
      document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) hide(); });
    });
  }

  /* ---------- boot ---------- */
  function boot() {
    initAgeGate();
    initMobileNav();
    initDrawer();
    initCartPage();
    initCountdown();
    initProduct();
    initRows();
    initDealTimers();
    initUntil();
    initHeroSlider();
    initRecent();
    initSuggest();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
